import { StepConfig } from '../../types/workflow';

const SendCsat: StepConfig = {
  // Design
  icon: 'CSAT',
  headerTextColor: '#25BEA6',
  headerColor: '#D6EFEE',
  title: 'CSAT',
  text: 'How would you rate our service?',
  category: 'Node',
  desc: 'CSAT survey responses.',
  primaryKey: 'content',
  // Form
  formFields: [
    {
      key: 'language',
      label: 'Language:',
      type: 'select',
      defaultValue: 'en',
      returnObject: false,
      options: [
        { label: 'Arabic', value: 'ar' },
        { label: 'English', value: 'en' },
      ],
      validation: {
        required: false,
      },
    },
    {
      key: 'content',
      label: 'Enter your message',
      placeholder: 'Leave your text here',
      type: 'textarea',
      defaultValue: '',
      validation: {
        required: true,
      },
    },
  ],
};

export default SendCsat;
